/**
 * Shared locale-aware formatters — use across mobile, web, and reports.
 */

export const APP_LOCALE = 'en-MY';

export function formatDate(isoOrYmd: string, options?: Intl.DateTimeFormatOptions): string {
  const d = isoOrYmd.includes('T') ? new Date(isoOrYmd) : new Date(`${isoOrYmd}T12:00:00`);

  return d.toLocaleDateString(APP_LOCALE, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options,
  });
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(APP_LOCALE, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Accepts ISO datetime or HH:mm from API. */
export function formatTime(value: string): string {
  const d = value.includes('T') ? new Date(value) : new Date(`1970-01-01T${value}`);
  if (Number.isNaN(d.getTime())) {
    return value;
  }

  return d.toLocaleTimeString(APP_LOCALE, { hour: '2-digit', minute: '2-digit' });
}

export function formatDays(
  n: number,
  options: { working?: boolean; decimals?: number } = {},
): string {
  const decimals = options.decimals ?? (Number.isInteger(n) ? 0 : 1);
  const formatted = decimals === 0 ? String(Math.round(n)) : n.toFixed(decimals);
  const unit = options.working ? 'working day' : 'day';
  const count = Number(formatted);

  return `${formatted} ${unit}${count === 1 ? '' : 's'}`;
}

export function formatHours(n: number): string {
  const formatted = Number.isInteger(n) ? String(n) : n.toFixed(1);

  return `${formatted}h`;
}

export function formatMinutes(n: number): string {
  return `${n} min`;
}

export function formatMoney(amount: number, decimals = 2): string {
  return new Intl.NumberFormat(APP_LOCALE, {
    style: 'currency',
    currency: 'MYR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount);
}
